import { inject, Injectable } from '@angular/core';
import { CheckoutValidator, Service, ServiceCodes, ValidationErrorKeys, ValidationErrors } from '@checkout-v2/const';
import { ServicesFacade } from '@checkout-v2/data-access';
import { StateUtils } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';
import { DeliveryAddressService } from './delivery-address.service';

@Injectable({
  providedIn: 'root',
})
export class ServicesService extends CheckoutValidator {
  private readonly servicesFacade = inject(ServicesFacade);
  private readonly deliveryAddressService = inject(DeliveryAddressService);

  getServicesState(): Observable<StateUtils.LoaderState<Service[]>> {
    return this.servicesFacade.getServicesState();
  }

  getServices(): Observable<Service[]> {
    return this.servicesFacade.getServices();
  }

  getServicesLoading(): Observable<boolean> {
    return this.servicesFacade.getServicesLoading();
  }

  getServicesError(): Observable<boolean> {
    return this.servicesFacade.getServicesError();
  }

  getServicesSuccess(): Observable<boolean> {
    return this.servicesFacade.getServicesSuccess();
  }

  getServicesActiveOptionCode(): Observable<ServiceCodes | undefined> {
    return this.servicesFacade.getServicesActiveOptionCode();
  }

  getServicesActiveOption(): Observable<Service | undefined> {
    return this.servicesFacade.getServicesActiveOption();
  }

  setServicesActiveOption(code: ServiceCodes | undefined): void {
    this.servicesFacade.setServicesActiveOption(code);
  }

  isEmptyOrHasError(): Observable<boolean> {
    return combineLatest({
      state: this.getServicesState(),
      addressListIsEmptyOrHasError: this.deliveryAddressService.isEmptyOrHasError(),
    }).pipe(
      map(
        ({ addressListIsEmptyOrHasError, state }) =>
          addressListIsEmptyOrHasError || !!state.error || (!!state.value && state.value.length === 0),
      ),
    );
  }

  getValidationErrors(): Observable<ValidationErrors> {
    return combineLatest({
      isEmptyOrHasError: this.isEmptyOrHasError(),
      activeService: this.getServicesActiveOption(),
      floorNotSpecified: this.deliveryAddressService.floorNotSpecified$,
    }).pipe(
      map(({ isEmptyOrHasError, activeService, floorNotSpecified }) => {
        const validationErrors: ValidationErrors = {};

        if (!isEmptyOrHasError && !activeService) {
          validationErrors[ValidationErrorKeys.SERVICE_REQUIRED] = 'выберите услугу';
        }

        if (activeService && activeService.code === ServiceCodes.Lifting && floorNotSpecified) {
          validationErrors[ValidationErrorKeys.FLOOR_NOT_SPECIFIED] = 'укажите этаж';
        }

        return validationErrors;
      }),
    );
  }
}
